import { useState, useEffect } from 'react';
import { getAuth, applyActionCode, checkActionCode } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Box, Button, useColorScheme } from '@mui/material';
import logoCabanaBlack from '../../images/logonextcabana-dark.svg';
import logoCabanaWhite from '../../images/logonextcabana-white.svg';
import AppTheme from '../../../frontend/shared-theme/AppTheme';
import LinearIndeterminate from '../../../frontend/components/LoadingLinear';

const EmailContent = () => {
  const auth = getAuth();
  const { mode, systemMode } = useColorScheme();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [userEmail, setUserEmail] = useState<string | null | undefined>('');
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const mode = params.get('mode');
    const oobCode = params.get('oobCode');

    if (mode !== 'verifyAndChangeEmail' || !oobCode) {
      setStatus('error');
      return;
    }

    checkActionCode(auth, oobCode).then((info) => {
      const email = info['data']['email'];
      setUserEmail(email);
    })

    applyActionCode(auth, oobCode)
      .then(async () => {
        setStatus('success');
      })
      .catch(err => {
        console.error(err);
        setStatus('error');
      });
  }, [auth]);

  if (status === 'loading') {
    return <LinearIndeterminate />;
  }

  return (
    <Container component="main" sx={{ maxWidth: 'xs', textAlign: 'center' }}>
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '40px' }}>
        <img
          src={mode === 'dark' || systemMode === 'dark' ? logoCabanaWhite : logoCabanaBlack}
          alt="logo-cabanalink"
          style={{ width: '300px', height: 'auto' }}
        />
      </div>
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {status === 'success' ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2,
              width: '100%',
            }}
          >
            <Typography component="h1" variant="h5" textAlign='center'>
              E-mail alterado com sucesso!
            </Typography>
            <Typography textAlign='center'>
              Faça o login com o novo e-mail <strong>{userEmail}</strong>.
            </Typography>
            <Button
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2, maxWidth: '200px' }}
              onClick={() => navigate('/signin')}
            >
              Fazer login
            </Button>
          </Box>
        ) : (
          <>
            <Typography component="h1" variant="h5" textAlign="center">
              Falha ao verificar o link.
            </Typography>
            <Typography textAlign="center">
              Tente novamente.
            </Typography>
          </>
        )}
      </Box>
    </Container>
  );
};

export default function ResetEmail(props: { disableCustomTheme?: boolean }) {
  return (
    <AppTheme {...props}>
      <EmailContent />
    </AppTheme>
  )
}